<template>
  <component
    :is="chartComponent"
    :id="id"
    :chartData="data"
    :data="data"
    :options="chartOptions"
    class="smart-chart" />
</template>

<script lang="ts" setup generic="T extends 'bar' | 'pie' | 'line'">
import { computed } from 'vue';
import { defaultConfig, chartTypesMap } from '@/components/Base/resources/BaseCharts/chartConfig';
import type { ChartOptions, ChartData } from 'chart.js';

const props = defineProps<{
  id: string;
  data: ChartData<T>;
  options?: ChartOptions<T>;
  type: T;
}>();

const chartComponent = chartTypesMap[props.type];

const chartOptions = computed(() => {
  return {
    ...(defaultConfig as any),
    ...props.options
  };
});
</script>

<style lang="scss">
.smart-chart {
  min-width: 100%;
  min-height: 100%;
  display: flex;
  > * {
    height: 100%;
    width: 100%;
  }
  canvas {
    width: 100%;
    height: auto;
    min-height: 20px;
  }
}
</style>
